// extracted by mini-css-extract-plugin
export default {"links":"Setting_links__cQCB7","link":"Setting_link__54pTP","logout":"Setting_logout__yGFWc","arrow":"Setting_arrow__TQdJy","browser":"Setting_browser__k8isa"};